import axios from "axios";

const API_BASE_URL = "https://ai.kesifaraci.com/service/api";

// Kullanıcı bilgilerini getirme servisi
const getUserDetails = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/users/userDetail`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user details:", error);
    throw error;
  }
};

const updateUserDetails = async (data, token) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/users/userUpdate`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data; 
    } catch (error) {
      console.error("Error updating user details:", error); 
      throw error
    }
  };

  const changeUserPassword = async (passwordData, token) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/users/userChangePassword`, passwordData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Error changing password:", error);
      throw error;
    }
  };

  
  

export default {
  getUserDetails,updateUserDetails,changeUserPassword
};
